import { permissions } from "@/permissions";
import { useUser } from "./useUser";
import type { Resource, Action } from "@typings/permissions";
import type { ROLES } from "@typings/entities/users/enums";

export function usePermissions() {
  const { role } = useUser();

  const can = (action: Action, resource: Resource): boolean => {
    if (!role) return false;

    const resourcePermissions = permissions[resource];
    if (!resourcePermissions) return false;

    const allowedRoles = resourcePermissions[action];
    if (!allowedRoles) return false;

    return allowedRoles.includes(role);
  };

  const hasPermission = (
    allowedRoles?: (typeof ROLES)[keyof typeof ROLES][],
  ): boolean => {
    if (!allowedRoles || allowedRoles.length === 0) return true;

    if (!role) return false;

    return allowedRoles.includes(role);
  };

  return { can, hasPermission };
}
